export const toISO8601UTC = (str: string) => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return `${str}T00:00:00Z`;
  if (str.includes('T')) return str.endsWith('Z') ? str : `${str}Z`;
  return str.replace(' ', 'T') + 'Z';
};

export const formatDate = (utcDate: string) => {
  if (!utcDate) return 'N/A';
  const isoDate = toISO8601UTC(utcDate);
  const date = new Date(isoDate);
  if (!isFinite(date.getTime())) return 'N/A';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short'
  }).format(date);
};

export const formatDateShort = (utcDate: string) => {
  if (!utcDate) return 'N/A';
  const isoDate = toISO8601UTC(utcDate);
  const date = new Date(isoDate);
  if (!isFinite(date.getTime())) return 'N/A';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).format(date);
};
